import React from 'react';
import { Moon, Sun } from 'lucide-react';
import Logo from './logo';
import { useLanguage } from '../contexts/language-context';
import LanguageSelector from './language-selector';

const Header = () => {
  const [isDark, setIsDark] = React.useState(true);
  const { t, language } = useLanguage();

  React.useEffect(() => {
    document.documentElement.classList.toggle('dark', isDark);
  }, [isDark]);

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 dark:bg-dark/95 backdrop-blur-sm z-50 border-b border-gray-200 dark:border-dark-lighter">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Logo />
          
          <nav className="flex items-center space-x-4 md:space-x-8">
            <a
              href={`https://wallet.feennex.com?lng=${language}`}
              target="_blank"
              rel="noopener noreferrer"
              className="hidden md:block text-gray-600 dark:text-gray-300 hover:text-neon-green-light dark:hover:text-neon-green transition-colors whitespace-nowrap"
            >
              {t('header.business')}
            </a>
            <button 
              onClick={() => setIsDark(!isDark)}
              className="text-gray-600 dark:text-gray-300 hover:text-neon-green-light dark:hover:text-neon-green p-2 rounded-lg"
            >
              {isDark ? <Sun size={20} /> : <Moon size={20} />}
            </button>
            <LanguageSelector />
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header